import script from "./fileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUpload.vue?vue&type=script&setup=true&lang=js"

import "./fileUpload.vue?vue&type=style&index=0&id=3888da43&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3888da43"]])

export default __exports__